$(document)
  .on('click', '#to_form', function() {
    $('html, body').animate({
      scrollTop: $('#sidebar').offset().top
    }, 800)
    $('#info_request_first_name').focus()
  })

  .on('turbolinks:load', () => {
    if ($('.package-paths').data('hide-pricing')) {
      $('.package-paths .pricing').css('display', 'none')
    }
  })
